import { UserOutlined } from '@ant-design/icons'

import type { OrganisationInterface } from '@/types'

import OrganisationBadges from '../OrganisationBadges/OrganisationBadges'
import generalCn from '../OrganisationsSearch.module.scss'
import cn from './OrganisationSuggestion.module.scss'

type OrganisationSuggestionPropsType = {
  organisation: OrganisationInterface
}

function OrganisationSuggestion({
  organisation,
}: OrganisationSuggestionPropsType) {
  const manager = organisation.supervisorManagerShortModel?.description

  return (
    <div className={cn.suggestion}>
      <span className={cn.name}>{organisation.description}</span>
      <div className={cn.details}>
        <span className={cn.manager}>
          {manager && (
            <span className={generalCn.metaItem}>
              <UserOutlined />
              {manager}
            </span>
          )}
        </span>
        <OrganisationBadges organisation={organisation} />
      </div>
    </div>
  )
}

export default OrganisationSuggestion
